/* CustomerInvoices.tsx
    Une page affichant la gestion des factures clients
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les factures clients
    Utilise l'API correspondante pour les opérations de données
*/

import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { CustomerInvoicesCrudCard } from 'features/customerInvoices/components/CustomerInvoicesCrudCard';
import PageHeader from 'layout/PageHeader';

export const CustomerInvoices = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faFileInvoiceDollar}
			title="Factures clients"
			subtitle="Gérez les factures de vos clients"
		/>
		<CustomerInvoicesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
